import { render } from "./articleDetail.vue?vue&type=template&id=7387728f&scoped=true&ts=true"
import script from "./articleDetail.vue?vue&type=script&lang=ts"
export * from "./articleDetail.vue?vue&type=script&lang=ts"

import "./articleDetail.vue?vue&type=style&index=0&id=7387728f&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7387728f"]])

export default __exports__